import React, { Component } from 'react';
import PlayerButton from './PlayerButton';
import Progress from './Progress';
import MediaCtrList from './MediaCtrList';
import { observer } from 'mobx-react';

import './ControlBar.css';
import './Progress.css';
import './MediaCtrList.css';

import { DataStore } from '../DataStore';

@observer
class ControlBar extends Component {
    timeUpdateHandler = (event) => {
        DataStore.currentTime = event.target.currentTime;
    }

    canPlayHandler = (event) => {
        DataStore.audio = event.target;
        DataStore.volume = DataStore.volume;
    }

    endedHandler = (event) => {
        DataStore.count = DataStore.count + 1;
    }

    setAudio = (url) => {
        if(url) {
            return (<audio 
                src={url} 
                style={{display:'none'}} 
                autoPlay={true}
                loop={DataStore.loop}
                ref='audio'
                volume={DataStore.silent?0:DataStore.volume}
                onTimeUpdate={this.timeUpdateHandler}
                onCanPlay={this.canPlayHandler}
                onEnded={this.endedHandler}
                />);
        }else{
            return null;
        }
    }

    render() {
        return (
          <div className="control-bal">
                <div id="audio-box" 
                    style={{display:'none'}}>
                    {this.setAudio(DataStore.coutSongMassge.PlayUrl)}
                </div>
                <div className="cb-main">
                    <PlayerButton />
                    <Progress />
                    <MediaCtrList />
                </div>
          </div>
        );
    }
}

export default ControlBar;


// WEBPACK FOOTER //
// ./src/components/ControlBar.js